import Scrollbars from 'react-custom-scrollbars-2';
import { makeAutoObservable, reaction, SDK } from 'sdk';

import { LoadingStore } from './loadingStore';

export class ScrollStore {
	constructor(private sdk: SDK, private loadingStore: LoadingStore) {
		makeAutoObservable(this);

		//При появлении непрочитанного сообщения, скролл вниз
		reaction(
			() => sdk.eventsStore.unreadMessages,
			() => {
				if (sdk.eventsStore.unreadMessages > 0) {
					this.scrollBar?.scrollToBottom();
				}
			}
		);
		//При начале отправки диалога сбрасываем последнюю позицию скролла
		reaction(
			() => sdk.startNewConversationRequestStatus,
			(v) => {
				if (v.isPending) {
					this.setLastScrollPosition(undefined);
				}
			}
		);

		//При появлении цитиуемого сообщения и последнее сообщение в поле видимости
		reaction(
			() => sdk.replyMessageStore.repliedMessage,
			() => {
				if (sdk.replyMessageStore.repliedMessage) {
					const messageTop = this.lastMessageRef?.getBoundingClientRect().top || 0,
						scrollHeight = this.scrollWrapper?.getBoundingClientRect().bottom || 0;
					if (messageTop < scrollHeight) {
						setTimeout(() => {
							this.scrollBar?.scrollToBottom();
						});
					}
				}
			}
		);
	}

	isBottom?: boolean;
	isTop?: boolean;
	scrollPosition?: number;
	lastScrollPosition?: number;
	scrollWrapper?: HTMLDivElement;
	scrollBar?: Scrollbars;
	listWrapper?: HTMLDivElement;
	lastMessageRef?: HTMLDivElement;
	prechatScroll?: Scrollbars;
	showScrollToBottom = false;

	setScrollBar = (el: Scrollbars): void => {
		this.scrollBar = el;
	};

	setPrechatScroll = (el: Scrollbars): void => {
		this.prechatScroll = el;
	};

	setScrollWrapper = (el: HTMLDivElement): void => {
		this.scrollWrapper = el;
	};
	setListWrapper = (el: HTMLDivElement): void => {
		this.listWrapper = el;
	};

	setIsTop = (b: boolean): void => {
		this.isTop = b;
	};

	setIsBottom = (b: boolean): void => {
		this.isBottom = b;
	};

	setScrollPosition = (n: number): void => {
		this.scrollPosition = n;
	};

	setLastScrollPosition = (n: number | undefined): void => {
		this.lastScrollPosition = n;
	};

	setLastMessageRef = (m: HTMLDivElement): void => {
		this.lastMessageRef = m;
	};

	setShowScrollToBottom = (b: boolean): void => {
		this.showScrollToBottom = b;
	};

	restoreScroll = (): boolean => {
		if (typeof this.scrollPosition !== 'undefined' && !this.isBottom && !this.sdk.eventsStore.unreadMessages) {
			return true;
		}
		return false;
	};

	delayedScroll = (cb: CallableFunction, delay: number): void => {
		this.sdk.uiStateStore.setShowLoading(true);
		setTimeout(() => {
			cb();
			this.sdk.uiStateStore.setShowLoading(false);
		}, delay);
	};

	scrollToBottom = (): void => this.scrollBar?.scrollToBottom();

	onScroll = (e: HTMLDivElement): void => {
		this.setScrollPosition(e.scrollTop);
		this.setIsBottom(e.scrollHeight - e.clientHeight === e.scrollTop);
		this.setIsTop(!e.scrollTop);

		//проверяем, скрыто ли последнее сообщение
		if (this.scrollWrapper && this.lastMessageRef) {
			this.setShowScrollToBottom(
				this.scrollWrapper.getBoundingClientRect().bottom < this.lastMessageRef.getBoundingClientRect().top
			);
		}
	};

	scrollToElm = async (eventId: number, conversationId: number | undefined): Promise<void> => {
		let replyMessageForScroll = document.getElementById(`ncc-message-${eventId}`);

		if (!replyMessageForScroll && conversationId) {
			this.loadingStore.setShowLoading(true);
			await this.sdk.loadHistoryMessagesUntil(conversationId);
			this.loadingStore.setShowLoading(false);
			this.scrollBar?.scrollToTop();
			replyMessageForScroll = document.getElementById(`ncc-message-${eventId}`);
		}

		if (replyMessageForScroll) {
			replyMessageForScroll.scrollIntoView({ behavior: 'smooth' });
		}
	};
}
